import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  updateTenantConfig,
  UpdateTenantConfigPayload,
  TenantListItem,
} from '../../api/queries';

const TENANTS_QUERY_KEY = ['GET_TENANTS'];

export const useUpdateTenantConfigMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      tenantId,
      payload,
    }: {
      tenantId: number;
      payload: UpdateTenantConfigPayload;
    }): Promise<TenantListItem> => {
      return updateTenantConfig(tenantId, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TENANTS_QUERY_KEY });
    },
  });
};
